module.exports = __webpack_public_path__ + "img/feito.34bcf97b.png";